<template>
  <div id="container" class="cs_st service_introduce">
    <!-- Location START -->
    <!-- TODO: ADD SUBBAR COMPONENT -->
    <!-- <BaseLocation current-group-name="information" /> -->
    <div class="background">
      <div class="section fill intro">
        <div class="background_pc c_txt_box">
          <h1>
            전자책 증정요청 가이드
          </h1>
          <img src="@/assets/images/new_detailpage/tit_under.png" alt="" />
          <p>
            캠퍼스북은 교재채택을 원하시는 교·강사분들에게 도움이 되고자<br />
            <em class="bg_yellow">전자책 증정 서비스</em>
            를 제공하고 있습니다.<br />
            학습에 필요한 다양한 기능을 지원하는
            <em class="bg_pink">캠퍼스북을 체험해 보세요.</em><br />
            <em class="bg_blue">편리하고 스마트한 강의 준비</em>
            를 도와드립니다.<br />
          </p>
        </div>
        <div class="background_pc custom_img">
          <img
            data-aos="fade-left"
            src="@/assets/images/new_detailpage/gift_banner_char.png"
            alt=""
          />
        </div>
        <div id="background_mb">
          <img
            class="leaf"
            src="@/assets/images/new_detailpage/bac_mb.png"
            alt=""
          />
          <h1>
            전자책 증정요청 가이드
          </h1>
          <img src="@/assets/images/new_detailpage/tit_under.png" alt="" />
          <p>
            캠퍼스북은 교재채택을 원하시는<br />
            교·강사분들에게 도움이 되고자<br />
            <em class="bg_yellow">전자책 증정 서비스</em>
            를 제공하고 있습니다.<br />
            학습에 필요한 다양한 기능을 지원하는<br />
            <em class="bg_pink">캠퍼스북을 체험해 보세요.</em><br />
            <em class="bg_blue">편리하고 스마트한 강의 준비</em>
            를 도와드립니다.<br />
          </p>
        </div>
      </div>
    </div>

    <div class="introduce_cont pb pt">
      <div class="sub_tit section fill" data-aos="fade-up">
        <img
          src="@/assets/images/new_detailpage/sub_tit.png"
          alt="서브타이틀이미지"
        />
        <h4>교·강사용 증정 이용방법</h4>
      </div>
      <div class="bg_box bg_box1">
        <div class="section fill c_wrap">
          <div class="float-left c_box01">
            <img
              src="@/assets/images/new_detailpage/1.png"
              alt="01"
              class="pc_01"
              style="width: 65px;"
            />
            <img
              src="@/assets/images/new_detailpage/1.png"
              alt="01"
              class="mb_01"
              style="width: 55px;"
            />
            <h2>회원가입</h2>
            <h5>
              회원가입 시 <em>꼭!</em> <br />
              교·강사 회원으로 가입해주세요.
            </h5>
            <p>
              ※ 일반회원으로 가입하셨다면 회원정보 수정에서 <br />
              <em class="pc_p" style="padding-left: 20px;">
                교·강사로 변경해주세요.
              </em>
              <em class="mb_p" style="padding-left: 14px;">
                교·강사로 변경해주세요.
              </em>
            </p>
          </div>
          <div class="float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/1_img.png"
              alt="회원가입"
            />
          </div>
        </div>
      </div>
      <div class="bg_box bg_box2">
        <div class="section fill c_wrap">
          <div class="float-left c_box01" style="padding-top: 95px;">
            <img src="@/assets/images/new_detailpage/2.png" alt="02" />
            <h2>증정요청</h2>
            <h5>
              증정 받으실 도서의 <br />
              출판사에 증정요청
            </h5>
            <p class="pc_p">
              교·강사 전용 메뉴에서 <br />
              증정 요청 페이지에 접속해 <br />
              증정을 원하시는 도서의 출판사를 확인 후 <br />
              이메일 혹은 전화로 요청하세요.
            </p>
            <p class="mb_p">
              교·강사 전용 메뉴에서 증정 요청 페이지에 접속해 <br />
              증정을 원하시는 도서의 출판사를 확인 후 <br />
              이메일 혹은 전화로 요청하세요.
            </p>
          </div>
          <div class="float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/2_img.png"
              alt="증정요청"
            />
          </div>
        </div>
      </div>
      <div class="bg_box bg_box1">
        <div class="section fill c_wrap">
          <div class="float-left c_box01" style="padding-top: 95px;">
            <img src="@/assets/images/new_detailpage/3.png" alt="03" />
            <h2>증정코드 발송</h2>
            <h5>
              출판사 확인 후 <br />
              증정코드 발송입력
            </h5>
            <p>
              <img
                src="@/assets/images/new_detailpage/3-1.png"
                alt="1번"
                class="num_3"
              />
              출판사에서 확인 후 이메일 혹은<br />
              <em style="padding-left: 27px;">
                SMS로 증정코드를 발송해 드립니다.
              </em>
            </p>
            <p style="margin-top: 0.5em;">
              <img
                src="@/assets/images/new_detailpage/3-2.png"
                alt="2번"
                class="num_3"
              />
              캠퍼스북 홈페이지에서 양식에 맞게<br />
              <em style="padding-left: 27px;">증정 코드 입력을 해주세요.</em>
            </p>
          </div>
          <div class="float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/3_img.png"
              alt="증정코드 발송"
            />
          </div>
        </div>
      </div>
      <div class="bg_box bg_box2 last_bg_box">
        <div class="section fill c_wrap">
          <div class="float-left c_box01">
            <img src="@/assets/images/new_detailpage/4.png" alt="04" />
            <h2>증정도서 확인</h2>
            <h5>
              증정도서 확인 후<br />
              e-Book 보기 버튼
            </h5>
            <p>
              내 서재에 ‘증정도서’ 탭이 생기고<br />
              e-Book 보기 버튼으로 확인하실 수 있습니다.
            </p>
          </div>
          <div class="float-right c_box01" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/4_img.png"
              alt="회원가입"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="f_banner">
      <div class="section fill pc_f_banner">
        <h4>전자책 증정 관련 공지사항</h4>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          증정본 열람기한은 증정코드 등록일로부터 20일까지 입니다.
        </p>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          증정가능 여부는 각 도서의 출판사가 판단하여 보내드리고 있습니다.
          증정관련 문의는 해당 출판사로 연락주시기를 바랍니다.
        </p>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          전자책은 스트리밍 방식으로 서비스되며, PC 등 기기에는 저장되지
          않습니다.
        </p>
      </div>
      <div class="section fill mb_f_banner">
        <h4>전자책 증정 관련 공지사항</h4>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          증정본 열람기한은 증정코드 등록일로부터<br />
          <em style="padding-left: 18px;">20일까지 입니다.</em>
        </p>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          증정가능 여부는 각 도서의 출판사가 판단하여<br />
          <em style="padding-left: 18px;">
            보내드리고 있습니다. 증정관련 문의는<br />
          </em>
          <em style="padding-left: 18px;">
            해당 출판사로 연락주시기를 바랍니다.
          </em>
        </p>
        <p>
          <img src="@/assets/images/new_detailpage/pink_dot.png" alt="" />
          전자책은 스트리밍 방식으로 서비스되며, <br />
          <em style="padding-left: 18px;">PC 등 기기에는 저장되지 않습니다.</em>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
// import { Swiper } from 'swiper/vue'
export default {
  name: 'GiftRequestGuide',
  data() {
    return {}
  },
  computed: {
    viewerSwiper() {
      return this.$refs.viewerSwiper.$swiper
    },
    ebookSwiper() {
      return this.$refs.ebookSwiper.$swiper
    }
  },
  mounted() {
    AOS.init()
    // let that = this
    // that.mySwiper.on('init', () => {
    //   that.getActiveIndex(this)
    //   console.log(that.getActiveIndex(this))
    // })
  },

  methods: {
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    },
    closeListMenu() {
      this.showListMenu = false
    },
    activeIndexChange(i) {
      console.log(i)
    },
    slideChangeEbook() {
      this.eBookPg = parseInt(this.ebookSwiper.activeIndex) + 1
    },
    slideChangeViewer() {
      this.viewerPg = parseInt(this.viewerSwiper.activeIndex) + 1
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css"></style>
<style lang="scss" scoped>
@font-face {
  font-family: 'NanumSquare';
  font-weight: 400;
  src: url('../../../src/assets/fonts/NanumSquareR.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 300;
  src: url('../../../src/assets/fonts/NanumSquareL.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 700;
  src: url('../../../src/assets/fonts/NanumSquareB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 800;
  src: url('../../../src/assets/fonts/NanumSquareEB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('ttf');
}
body,
h1,
h4,
p {
  font-family: 'NanumSquare', sans-serif !important;
}
.bg_yellow {
  background: linear-gradient(to top, #fcf59d 50%, transparent 50%);
}
.bg_pink {
  background: linear-gradient(to top, #f49fbd 50%, transparent 50%);
}
.bg_blue {
  background: linear-gradient(to top, #66c4ff 50%, transparent 50%);
}
.mb_01,
.mb_p {
  display: none;
}
#background_mb {
  display: none;
}
.mb_f_banner {
  display: none;
}
.section.fill {
  width: 100%;
  max-width: 1120px;
}

.cs_st.service_introduce .background {
  background: url('../../assets/images/new_detailpage/giftguide_banner.png')
    center no-repeat;
  background-size: cover;
}
.cs_st.service_introduce .intro.fill {
  // height: 630px;
  max-height: 630px;
  height: 33.802083vw;
  background: none;
  h1 {
    font-size: 2.5em;
    padding-top: 120px;
    margin-bottom: 20px;
    color: #1c929b;
  }
  p {
    font-size: 1.714em;
    padding-top: 40px;
    font-weight: lighter;
  }
}

.sub_tit {
  padding: 90px 0 43px;
  text-align: center;
  font-size: 2.214em;
  h4 {
    margin-top: 1.071em;
    font-weight: 900;
  }
}
.bg_box {
  position: relative;
  max-width: 1903px;
  margin: auto;
  height: 560px;
  background: url('../../assets/images/new_detailpage/bg_box1.png') right
    no-repeat;
  margin-bottom: 94px;
  .section.fill {
    background: none;
    .float-left {
      padding: 100px 0;
      img {
        width: 80px;
      }
      .num_3 {
        width: 23px;
        vertical-align: middle;
      }
      h2 {
        font-size: 3.286em;
        color: #878787;
        padding-top: 40px;
      }
      h5 {
        font-size: 1.714em;
        padding: 15px 0;
        font-weight: 500;
        em {
          color: #ff0000;
        }
      }
      p {
        font-size: 1.214em;
        line-height: 25px;
      }
    }
    .float-right {
      position: absolute;
      right: -200px;
      top: 70px;
    }
  }
}

.bg_box.bg_box2 {
  background: url('../../assets/images/new_detailpage/bg_box2.png') right
    no-repeat;
}

.f_banner {
  width: 100%;
  padding: 65px 0;
  color: #fff;
  background: url('../../assets/images/new_detailpage/f_banner.png') center
    no-repeat;
  background-size: cover;
  .section.fill {
    background: none;
  }
  h4 {
    font-size: 1.5em;
    padding-bottom: 30px;
  }
  p {
    font-size: 1.214em;
    line-height: 35px;
    img {
      padding-right: 5px;
    }
  }
}

@media (max-width: 1120px) {
  .bg_box .section.fill {
    padding-left: 50px;
    padding-right: 50px;
    .float-right {
      top: 110px;
      right: -250px;
      img {
        width: 75%;
      }
    }
  }
}

@media (max-width: 830px) {
  .background_pc {
    display: none;
  }
  #background_mb {
    display: block;
  }
  .pc_01,
  .pc_p {
    display: none;
  }
  .mb_01,
  .mb_p {
    display: block;
  }
  .mb_f_banner {
    display: block;
  }
  .pc_f_banner {
    display: none;
  }

  .cs_st.service_introduce .background {
    height: 740px;
    background: url('../../assets/images/new_detailpage/giftguide_banner_mb.png')
      bottom no-repeat;
    background-color: #d3ecf0;
    #background_mb {
      padding-left: 10px;
      .leaf {
        width: 60px;
        padding-top: 60px;
      }
      h1 {
        padding-top: 10px;
        margin-bottom: 5px;
      }
      p {
        font-size: 18px;
        line-height: 32px;
      }
    }
  }
  .sub_tit {
    padding: 90px 0 20px;
    img {
      width: 37px;
    }
    h4 {
      font-size: 22px;
      margin-top: 15px;
    }
  }
  .bg_box.bg_box2 {
    background: none;
    background-color: #f0f4f7;
  }
  .bg_box {
    background: none;
    height: auto;
    background-color: #d3ecf0;
    margin-bottom: 50px;
    .section.fill {
      padding: 80px 50px;
      .float-left {
        float: none;
        padding: 0px 0 30px !important;
        img {
          width: 65px;
        }
        .num_3 {
          width: 18px;
          vertical-align: middle;
        }
        em {
          padding-left: 22px !important;
        }
        h2 {
          font-size: 38px;
          padding-top: 20px;
        }
        h5 {
          font-size: 19px;
          padding: 8px 0;
        }
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
      .float-right {
        position: static;
        float: none;
        img {
          width: 362px;
        }
      }
    }
  }
  .last_bg_box {
    margin-bottom: 0;
  }
  .f_banner {
    padding: 30px 20px;
  }
  .f_banner .mb_f_banner {
    p {
      line-height: 25px;
      margin-bottom: 10px;
    }
  }
}
@media screen and (min-width: 831px) and (max-width: 1280px) {
  .c_txt_box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 24px;
    padding-left: 20px;
    > img {
      width: 38px !important;
      height: 6px !important;
    }
    > h1 {
      padding-top: 0 !important;
      font-size: 2em !important;
      margin-bottom: 16px !important;
    }
    > p {
      font-size: 1.25em !important;
      padding-top: 24px !important;
      line-height: 26px !important;
    }
  }
  .bg_box {
    height: auto;
  }
  .c_wrap {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > .c_box01.float-left {
      padding: 64px 0 !important;
      min-width: 366px;
    }
    > .float-right {
      position: static !important;
      &.c_box01 > img {
        height: 27.1875vw;
        width: auto !important;
      }
      &.c_box02 > img {
        height: 30vw;
        width: auto !important;
      }
      &.c_box03 > img {
        height: 36vw;
        width: auto !important;
      }
    }
  }
}
.custom_img {
  position: absolute;
  height: 70%;
  bottom: 10%;
  left: calc(38% + 20vw);
  transform: none;
  > img {
    height: 100%;
  }
}
</style>
